export default "__VITE_ASSET__DZm8u4uM__"